// extracted by mini-css-extract-plugin
export var darkMode = "_18-0";